import { useQuery } from '@tanstack/vue-query';

import { fetchUsers } from '@/api/basecamp.api';
import { toSelectableUser } from '@/store/modules/users.store';
import type { IContactPerson, IPermission } from '@condo/domain';
import { difference, lowerCase, partition, sortBy } from 'lodash-es';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { store } from '../store';

export const useUsers = () => {
    const queryData = useQuery(['users'], fetchUsers, {
        initialData: [],
    });

    const transformedActiveUsers = computed(() => {
        const [, activeUsers] = partition(queryData.data.value, user => user.disabled);
        return sortBy(
            activeUsers.filter?.(u => !!u.email).map(u => toSelectableUser(u)),
            user => lowerCase(user.displayName),
        );
    });
    return {
        ...queryData,
        activeUsers: transformedActiveUsers,
    };
};

// @note this is always set as it is set during bootstrap phase
export const useSelfUser = () => {
    return computed(() => store.getters.user as IContactPerson);
};

export const useHasPermissions = () => {
    const store = useStore();
    const isAdmin = computed(() => store.getters.isAdmin);

    const user = useSelfUser();

    const hasPermission = (...requiredPermissions: IPermission[]) => {
        if (isAdmin.value) {
            return true;
        }
        if (!user.value) {
            return false;
        }
        const missingPermissions = difference(requiredPermissions, (user.value as any).permissions);

        return missingPermissions.length === 0;
    };
    return {
        hasPermission,
    };
};
